export const ATTENDANCE = '/attendance'
export const ATTENDANCE_LESSONS = `${ATTENDANCE}-lessons`
export const ATTENDANCE_STUDENTS = `${ATTENDANCE}-students`
export const ATTENDANCE_LIST = `${ATTENDANCE}-list`
